/* BushLine — FAQ "Quick Checks" look ("Simple 2" look, 30 Sep 2026).
   Turns any FAQ answer written in the "checks" shape into a tick-as-you-go checklist with fold-open checks.
   The shape, as stored in the answer text (richtext or HTML):
     <p>intro…</p>
     <p><strong>Quick Checks — Tick as you Go</strong></p>
     <ul><li>First check question?</li><li>Second…</li></ul>
     <p><strong>1. First Check Heading</strong></p>
     <ol><li>What you see (bold words show red)…</li></ol>
     <ul><li>What to do…</li></ul>
     <p><strong>2. Second Check Heading</strong></p> …
   Without this script the same answer still reads as plain ticks and crosses. Styles: bushline-faq-checks.css. */
(function () {
  if (window.blFaqChecks) return;
  window.blFaqChecks = true;

  var isLabelPara = function (el) {
    return el && el.tagName === 'P' && el.children.length === 1 && el.firstElementChild.tagName === 'STRONG' &&
      el.textContent.trim() === el.firstElementChild.textContent.trim();
  };

  function build(qp) {
    var box = qp.parentElement;
    if (!box || box.querySelector('.bl-quick')) return;
    var list = qp.nextElementSibling;
    if (!list || list.tagName !== 'UL') return;
    var questions = Array.prototype.map.call(list.children, function (li) { return li.innerHTML; });

    // Gather the checks: each numbered bold heading and the lines after it.
    var checks = [], cur = null, n = list.nextElementSibling;
    while (n) {
      var next = n.nextElementSibling;
      if (isLabelPara(n) && /^\d+\.\s/.test(n.textContent.trim())) {
        cur = { title: n.textContent.trim().replace(/^\d+\.\s*/, ''), nodes: [], head: n };
        checks.push(cur);
      } else if (cur) {
        cur.nodes.push(n);
      }
      n = next;
    }
    if (!checks.length) return;
    box.classList.add('bl-checks');

    // The checklist box.
    var quick = document.createElement('div');
    quick.className = 'bl-quick';
    var head = document.createElement('p');
    head.className = 'bl-qh';
    head.innerHTML = qp.firstElementChild.innerHTML + '<span class="bl-count"></span>';
    quick.appendChild(head);
    var boxes = questions.map(function (q, i) {
      var label = document.createElement('label');
      var input = document.createElement('input');
      input.type = 'checkbox';
      label.appendChild(input);
      var span = document.createElement('span');
      span.innerHTML = (i + 1) + '. ' + q;
      label.appendChild(span);
      quick.appendChild(label);
      return input;
    });
    box.insertBefore(quick, qp);
    qp.remove();
    list.remove();

    // The fold-open checks.
    var secs = checks.map(function (c, i) {
      var sec = document.createElement('div');
      sec.className = 'bl-sec is-shut';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bl-sh';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="bl-num">' + (i + 1) + '</span><span class="bl-tt"></span><span class="bl-tw"></span>';
      btn.querySelector('.bl-tt').textContent = c.title;
      var bd = document.createElement('div');
      bd.className = 'bl-bd';
      c.nodes.forEach(function (node) {
        if (node.tagName === 'UL') {
          Array.prototype.forEach.call(node.children, function (li) {
            var chip = document.createElement('span');
            chip.className = 'bl-chip';
            chip.textContent = '✔ Do This';
            li.insertBefore(chip, li.firstChild);
          });
        }
        bd.appendChild(node);
      });
      sec.appendChild(btn);
      sec.appendChild(bd);
      c.head.parentElement.replaceChild(sec, c.head);
      btn.addEventListener('click', function () { setShut(sec, !sec.classList.contains('is-shut')); });
      return sec;
    });

    function label(sec) {
      var done = sec.classList.contains('is-done'), shut = sec.classList.contains('is-shut');
      sec.querySelector('.bl-tw').textContent = done ? '✔ Checked' : (shut ? 'Show How ▾' : 'Hide ▴');
      sec.querySelector('.bl-sh').setAttribute('aria-expanded', shut ? 'false' : 'true');
    }
    function setShut(sec, shut) { sec.classList.toggle('is-shut', shut); label(sec); }
    function count() {
      var k = boxes.filter(function (b) { return b.checked; }).length;
      head.querySelector('.bl-count').textContent = k === boxes.length ? 'All Checked' : k + ' of ' + boxes.length + ' Checked';
      quick.classList.toggle('is-all', k === boxes.length);
    }
    boxes.forEach(function (b, i) {
      b.addEventListener('change', function () {
        b.parentElement.classList.toggle('is-ticked', b.checked);
        var sec = secs[i];
        if (!sec) return count();
        sec.classList.toggle('is-done', b.checked);
        sec.querySelector('.bl-num').textContent = b.checked ? '✔' : String(i + 1);
        if (b.checked) sec.classList.add('is-shut');
        label(sec);
        count();
      });
    });
    secs.forEach(label);
    count();
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-faq-answer] p > strong:first-child'), function (s) {
      var p = s.parentElement;
      if (isLabelPara(p) && /^quick checks/i.test(p.textContent.trim())) build(p);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
